class CartCouponTimer extends HTMLElement {
  connectedCallback() {
    if (this.dataset.timerReady === "true") return;

    this.dataset.timerReady = "true";
    this.duration = Math.max(1, Number.parseInt(this.dataset.duration || "900", 10));
    this.couponCode = (this.dataset.couponCode || "").trim().toLowerCase();
    try {
      this.storage = this.dataset.persistence === "browser" ? window.localStorage : window.sessionStorage;
    } catch (error) {
      this.storage = null;
    }
    this.storageKey = `marea:coupon-timer:${this.couponCode}`;
    this.hoursElement = this.querySelector("[data-timer-hours]");
    this.minutesElement = this.querySelector("[data-timer-minutes]");
    this.secondsElement = this.querySelector("[data-timer-seconds]");

    if (!this.couponCode || !this.hoursElement || !this.minutesElement || !this.secondsElement) return;

    this.expiresAt = this.readExpiry();
    this.hidden = false;
    this.tick();
    this.interval = window.setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    window.clearInterval(this.interval);

    window.setTimeout(() => {
      const sameCouponStillApplied = Array.from(document.querySelectorAll("cart-coupon-timer[data-coupon-code]"))
        .some((timer) => (timer.dataset.couponCode || "").trim().toLowerCase() === this.couponCode);

      if (!sameCouponStillApplied) this.removeStoredExpiry();
    }, 0);
  }

  readExpiry() {
    const now = Date.now();
    let storedExpiry = 0;

    try {
      storedExpiry = Number.parseInt(this.storage.getItem(this.storageKey) || "0", 10);
    } catch (error) {
      storedExpiry = 0;
    }

    if (Number.isFinite(storedExpiry) && storedExpiry > 0) return storedExpiry;

    const expiresAt = now + this.duration * 1000;

    try {
      this.storage.setItem(this.storageKey, String(expiresAt));
    } catch (error) {
      // O contador continua funcional mesmo se o navegador bloquear o armazenamento.
    }

    return expiresAt;
  }

  removeStoredExpiry() {
    if (!this.storageKey || !this.storage) return;

    try {
      this.storage.removeItem(this.storageKey);
    } catch (error) {
      // Sem ação: a ausência de armazenamento não afeta o carrinho.
    }
  }

  tick() {
    const remaining = Math.max(0, Math.ceil((this.expiresAt - Date.now()) / 1000));
    const hours = Math.floor(remaining / 3600);
    const minutes = Math.floor((remaining % 3600) / 60);
    const seconds = remaining % 60;

    this.hoursElement.textContent = String(hours).padStart(2, "0");
    this.minutesElement.textContent = String(minutes).padStart(2, "0");
    this.secondsElement.textContent = String(seconds).padStart(2, "0");

    if (remaining > 0) return;

    window.clearInterval(this.interval);
    this.classList.add("is-expired");

    if (this.dataset.expiredBehavior === "hide") this.hidden = true;
  }
}

if (!customElements.get("cart-coupon-timer")) {
  customElements.define("cart-coupon-timer", CartCouponTimer);
}
